import { defineComponent as _defineComponent } from 'vue'
import CallToAction from '@/features/global-home/components/CallToAction.vue';
import GlobalCards from '@/features/global-home/components/card/GlobalCards.vue';
import GlobalHero from '@/features/global-home/components/GlobalHero.vue';
import GlobalLargeSpotlight from '@/features/global-home/components/GlobalLargeSpotlight.vue';
import GlobalProviderSpotlight from '@/features/global-home/components/GlobalProviderSpotlight.vue';
import GlobalSmallSpotlight from '@/features/global-home/components/GlobalSmallSpotlight.vue';
import GlobalSports from '@/features/global-home/components/sports/GlobalSports.vue';
import GlobalTitles from '@/features/global-home/components/GlobalTitles.vue';

import CountriesList from '@/components/countries-list/CountriesList.vue';

import { useConstantStore, useLanguageStore } from '@/helpers/composables/useStores';

import { COUNTRY_EXCEPTIONS } from '@/constants/web-locales.constant';
import { ObjectType } from '@/@types/graphql-types';
import { isSportSupported } from '@/enums/sports';

import { computed } from 'vue';

// Hardcoded value for now @liam.best

export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalHome',
  setup(__props) {

const spotlightProvider = { shortName: 'atp' };

const logoSrc = `/${ASSETS_DIR}/img/home/logo.svg`;

const { providersByShortName } = useConstantStore();
const { country, language, webLocale } = useLanguageStore();

const hasSports = computed(() => {
	const isException = COUNTRY_EXCEPTIONS[webLocale.value];
	if (isException) {
		return isSportSupported(isException);
	}

	return isSportSupported(webLocale.value);
});

return { __sfc: true,spotlightProvider, logoSrc, providersByShortName, country, language, webLocale, hasSports, CallToAction, GlobalCards, GlobalHero, GlobalLargeSpotlight, GlobalProviderSpotlight, GlobalSmallSpotlight, GlobalSports, GlobalTitles, CountriesList, ObjectType }
}

})